import { z } from 'zod';
/**
 * Formato único de erro da API. O admin traduz `code` para uma mensagem de
 * operador; `message` já vem em pt-BR e nunca contém stack trace.
 */
export const API_ERROR_CODES = [
    'BAD_REQUEST',
    'UNAUTHENTICATED',
    'SESSION_EXPIRED',
    'FORBIDDEN',
    'NOT_FOUND',
    'CONFLICT',
    'VALIDATION_ERROR',
    'RATE_LIMITED',
    /// O pedido estava certo; quem recusou foi um serviço de fora (o gateway
    /// de pagamento, por exemplo). A mensagem vem de lá, em português.
    'BAD_GATEWAY',
    'INTERNAL',
];
export const apiErrorCodeSchema = z.enum(API_ERROR_CODES);
export const fieldIssueSchema = z.object({
    path: z.string(),
    message: z.string(),
});
export const apiErrorSchema = z.object({
    error: z.object({
        code: apiErrorCodeSchema,
        message: z.string(),
        /** Detalhe por campo — preenchido em VALIDATION_ERROR (422). */
        issues: z.array(fieldIssueSchema).optional(),
        /** Correlaciona a resposta com a linha do log e do AuditLog. */
        requestId: z.string().optional(),
    }),
});
/** Mensagem de fallback exibida ao operador quando a API não mandou texto. */
export const ERROR_MESSAGES = {
    BAD_REQUEST: 'Não foi possível entender a solicitação.',
    UNAUTHENTICATED: 'Faça login para continuar.',
    SESSION_EXPIRED: 'Sua sessão expirou. Entre novamente.',
    FORBIDDEN: 'Você não tem permissão para esta ação.',
    NOT_FOUND: 'Registro não encontrado.',
    CONFLICT: 'Este registro conflita com outro já existente.',
    VALIDATION_ERROR: 'Revise os campos destacados no formulário.',
    RATE_LIMITED: 'Muitas tentativas. Aguarde alguns instantes.',
    BAD_GATEWAY: 'O serviço externo recusou a operação. Veja o detalhe e tente de novo.',
    INTERNAL: 'Ocorreu um erro inesperado. A equipe técnica foi notificada.',
};
/** Código HTTP correspondente a cada erro de negócio. */
export const ERROR_STATUS = {
    BAD_REQUEST: 400,
    UNAUTHENTICATED: 401,
    SESSION_EXPIRED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    CONFLICT: 409,
    VALIDATION_ERROR: 422,
    RATE_LIMITED: 429,
    BAD_GATEWAY: 502,
    INTERNAL: 500,
};
//# sourceMappingURL=errors.js.map